import { CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot, 
    Router} from "@angular/router";
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { Stitch, StitchAppClient } from 'mongodb-stitch-browser-sdk';
import {
  HttpServiceClient,
  HttpRequest,
  HttpMethod
} from 'mongodb-stitch-browser-services-http';
import { HttpClient } from '@angular/common/http';
import { Api } from 'src/app/provider/api';



 @Injectable()
export class UserService{
    
  
    constructor(private api:Api){
   
    }

    /***
     * Get all instructors and cache data. Use this list of instructors to find user based on id
     */
    getAllInstructor(body : any){
       let instructorList = this.api.post("userService/incoming_webhook/getUserDetails",body);
       instructorList.subscribe((res: any)=>{
       
         //  console.log(res);
          }, err => {
            console.error('ERROR', err)
          });
        return instructorList;
    }
    

       /***
     * Get Plan ID or Lost of Plans - If passed Null Bring all plans if passed id get 
     * Specific plans
     * https://us-east-1.aws.webhooks.mongodb-stitch.com/api/client
     * /v2.0/app/drbeen-stage-zujks/service/userService/incoming_webhook/planDetails
     */
    getPlanDetails(body : any){
      let planList = this.api.post("userService/incoming_webhook/planDetails",body);
      planList.subscribe((res: any)=>{
      
        //  console.log(res);
         }, err => {
           console.error('ERROR', err)
         });
       return planList;
   }
   


       
    
    }